/** Battery ID aliases — first column + frozen when present. */
export const DIAGNOSTICS_BATTERY_ALIASES = ['batteryid', 'battery_id'];

/** Device ID aliases — hidden from Event Summary only. */
const EVENT_SUMMARY_HIDDEN = new Set(['deviceid', 'device_id']);

/**
 * Event Summary priority groups: first matching alias per group wins.
 * Remaining keys keep API insertion order.
 */
const EVENT_SUMMARY_PRIORITY_GROUPS = [
  DIAGNOSTICS_BATTERY_ALIASES,
  ['eventtype', 'event_type'],
  ['eventstatus', 'event_status'],
  ['createddate', 'created_date', 'created_at'],
  ['time'],
  ['updateddate', 'updated_date', 'updated_at'],
  ['updated_by', 'updatedby'],
  ['temp', 'temperature', 'externaltemperature'],
  ['slot'],
  ['soc'],
  ['extra1', 'extra_1'],
  ['extra2', 'extra_2'],
  ['user_remark', 'userremarks', 'user_remarks', 'remarks'],
];

function findFirstAlias(keys, aliases) {
  const keySet = new Set(keys);
  return aliases.find((key) => keySet.has(key));
}

function buildHeadersFromPriorityGroups(rawKeys, { hidden = new Set(), priorityGroups = [] }) {
  const visible = rawKeys.filter((key) => !hidden.has(key));
  const visibleSet = new Set(visible);

  const prioritized = [];
  const placed = new Set();

  priorityGroups.forEach((group) => {
    const match = group.find((key) => visibleSet.has(key));
    if (match) {
      prioritized.push(match);
      placed.add(match);
    }
  });

  const remainder = visible.filter((key) => !placed.has(key));
  return [...prioritized, ...remainder];
}

/**
 * Move Battery ID to the front; preserve relative order of all other columns.
 * @param {string[]} rawKeys
 * @returns {string[]}
 */
export function buildBatteryFirstHeaders(rawKeys) {
  const batteryKey = findFirstAlias(rawKeys, DIAGNOSTICS_BATTERY_ALIASES);
  if (!batteryKey) return rawKeys;
  return [batteryKey, ...rawKeys.filter((key) => key !== batteryKey)];
}

/**
 * Event Summary: custom column order, Device ID hidden, Extra 2 after Extra 1.
 * @param {string[]} rawKeys
 * @returns {string[]}
 */
export function buildEventSummaryHeaders(rawKeys) {
  return buildHeadersFromPriorityGroups(rawKeys, {
    hidden: EVENT_SUMMARY_HIDDEN,
    priorityGroups: EVENT_SUMMARY_PRIORITY_GROUPS,
  });
}

/**
 * @param {string[]} headers
 * @returns {string|undefined}
 */
export function resolveBatteryStickyKey(headers) {
  return findFirstAlias(headers, DIAGNOSTICS_BATTERY_ALIASES);
}
